import { ActionService } from 'dashboard-services/services';

export default (() => {
  const AI_PARSER_FILE_UPLOAD_PREFIX = "AI_PARSER_FILE_UPLOAD_PREFIX",
        AI_PARSER_FILE_UPLOAD_CHECK_PREFIX = "AI_PARSER_FILE_UPLOAD_CHECK_PREFIX",
        AI_PARSER_PROMPT_GENERATE_PREFIX = "AI_PARSER_PROMPT_GENERATE_PREFIX",
        AI_PARSER_OUTPUT_GENERATE_PREFIX = "AI_PARSER_OUTPUT_GENERATE_PREFIX"
  
  const ON_CHANGE = 'ON_CHANGE_AI_PARSER'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const CLEAR = 'CLEAR_AI_PARSER'
  const clear = ActionService.makeActionCreator(CLEAR)

  const clearExpectedOutputFile = () => dispatch => {
    dispatch(onChange(undefined, "expectedOutputFile"))
    dispatch(onChange(undefined, "expectedOutputFileRaw"))
    dispatch(onChange(undefined, "expectedOutputFileInfo"))
  }

  return {
    onChange,
    ON_CHANGE,
    AI_PARSER_FILE_UPLOAD_PREFIX,
    AI_PARSER_FILE_UPLOAD_CHECK_PREFIX,
    AI_PARSER_PROMPT_GENERATE_PREFIX,
    AI_PARSER_OUTPUT_GENERATE_PREFIX,
    clear,
    CLEAR,
    clearExpectedOutputFile
  }
})()